/**
 * 工序模块枚举定义
 *
 * @description 全局工序定义的枚举类型
 * @module types/operation/enums
 * @category Operation - 工序管理
 *
 * @last-updated 2025-12-12
 */

/**
 * 工序类型
 */
export enum OperationType {
  /** 加工 */
  PROCESSING = 'PROCESSING',
  /** 装配 */
  ASSEMBLY = 'ASSEMBLY',
  /** 检验 */
  INSPECTION = 'INSPECTION',
  /** 包装 */
  PACKAGING = 'PACKAGING',
  /** 备料 */
  MATERIAL_PREP = 'MATERIAL_PREP',
  /** 转移 */
  TRANSFER = 'TRANSFER',
  /** 返工 */
  REWORK = 'REWORK',
  /** 其他 */
  OTHER = 'OTHER',
}

/**
 * 检验类型
 */
export enum OperationInspectionType {
  /** 无需检验 */
  NONE = 'NONE',
  /** 自检 */
  SELF = 'SELF',
  /** 巡检 */
  PATROL = 'PATROL',
  /** 全检 */
  FULL = 'FULL',
  /** 抽检 */
  SAMPLING = 'SAMPLING',
  /** 首件检验 */
  FIRST_ARTICLE = 'FIRST_ARTICLE',
}

/**
 * 工序状态
 */
export enum OperationStatus {
  /** 启用 */
  ACTIVE = 'ACTIVE',
  /** 停用 */
  INACTIVE = 'INACTIVE',
  /** 草稿 */
  DRAFT = 'DRAFT',
}

/**
 * 工艺路线工序状态
 */
export enum RouteOperationStatus {
  /** 启用 */
  ACTIVE = 'ACTIVE',
  /** 停用 */
  INACTIVE = 'INACTIVE',
}
